import React from 'react';
import Modal from '@mui/joy/Modal';
import Button from '@mui/joy/Button';
import ModalClose from '@mui/joy/ModalClose';
import { IVenue } from 'btdt-types';
import SuggestEditForm from '../../../SuggestEditForm/SuggestEditForm';
import { useDevices } from '../../../helpers/devices';

interface IProps {
  venue: IVenue;
}

function SuggestEditButton({ venue }: IProps): React.ReactElement {
  const { isMobile } = useDevices();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <div className="VenueDetails-contribute">
        <p style={{ margin: '0 0 8px 0' }}>מצאת טעות? יש לך מידע נוסף?</p>
        <Button type="button" onClick={() => setIsOpen(true)} size="sm">
          הציעו תיקון
        </Button>
      </div>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: isMobile ? 'flex-start' : 'center', marginTop: isMobile ? '24px' : 0 }}
      >
        <div style={{ position: 'relative' }}>
          <ModalClose
            variant="outlined"
            sx={{
              top: 'calc(-1/4 * var(--IconButton-size))',
              left: 'calc(-1/4 * var(--IconButton-size))',
              right: 'auto',
              boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
              borderRadius: '50%',
              bgcolor: 'background.surface',
            }}
          />
          <SuggestEditForm venue={venue} onDone={() => setIsOpen(false)} />
        </div>
      </Modal>
    </>
  );
}

export default SuggestEditButton;
